import { reducer as summary } from "./summary/slice";

export const reducer = {
  summary,
};
